import GenericChart from './GenericChart';

export default GenericChart;
